import { useEffect, useState } from "react";

/** True while the CSS media query matches; follows resizes and rotation. */
export function useMediaQuery(query) {
  const get = () => typeof window !== "undefined" && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMatches(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return matches;
}

/** Desktop layout = the side menu is showing (Tailwind `lg`, 1024px+). */
export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");
